import React from 'react'

const containerId = 'lastViewedProductsContainer'

const LastViewedContainer = () => {
  // 1px for handling scroll event
  return <div style={{ gridArea: 'last-viewed', minHeight: '1px' }} id={containerId} />
}

export default React.memo(LastViewedContainer)
